import './Landing.css'
import Header from '../Header/Header'
import Hero from '../Hero/Hero'
import ExtensionInfo from '../ExtensionInfo/ExtensionInfo'

const Landing = () => {
  return (
    <div>
      <Header/>
      <Hero/>
      <ExtensionInfo/>
    </div>
    
  )
}

export default Landing
